<template>
  <div v-if="this.show">
    <br />
    <b-alert class="myAlert center info" show>
      {{ this.description }}
      <br /><br />
      {{ this.menuLink }}
    </b-alert>
  </div>
</template>

<script>
import BookingDetailModel from "@/models/bookingDetailModel";
import { mapActions } from "vuex";

export default {
  name: "ClockActivity",
  props: ["token"],
  data() {
    return {
      show: false,
      description: "",
      menuLink: "",
    };
  },
  created() {
    this.checkToken();
  },
  methods: {
    ...mapActions(["updateHideAll"]),
    checkToken() {
      if (!this.token) {
        return;
      }

      let data = {
        token: this.token,
      };

      let bookingDetailModel = new BookingDetailModel();

      bookingDetailModel
        .checkToken(data)
        .then((res) => {
          if (res) {
            let result = res.response.data;

            if (result.error) {
              if (result.error == "Expired token") {
                this.updateHideAll();
                this.getInformation("expiredToken");
                return;
              }
            }

            /**if token is validated, render the job detail view*/
            if (result.job_id > 0 && result.interpreter_id != "") {
              let fmInterpreterId = localStorage
                .getItem("fmInterpreterId")
                .toLowerCase();
              if (fmInterpreterId == result.interpreter_id.toLowerCase()) {
                this.$router.push({
                  path: "/bookingdetail/" + result.job_id + "/BookingConfirmed",
                });
                return;
              } else {
                this.updateHideAll();
                this.getInformation("invalidToken");
                return;
              }
            } else {
              this.updateHideAll();
              this.getInformation("invalidToken");
              return;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          debugger;
        });
    },
    getInformation(status) {
      this.show = true;
      switch (status) {
        case "invalidToken":
          this.description =
            "You do not have access to this booking. To view current confirmed bookings, please go to menu:";
          this.menuLink = "Bookings -> Current Confirmed";
          break;
        case "expiredToken":
          this.description =
            "Booking token has expired. To view current confirmed bookings, please go to menu:";
          this.menuLink = "Bookings -> Current Confirmed";
          break;
        default:
          this.description =
            "Oops! Something went wrong. To view current confirmed bookings, please go to menu:";
          this.menuLink = "Bookings -> Current Confirmed";
          break;
      }
    },
  },
};
</script>
